const reportDB = require("../../../../../components/report/report-db");
const style = require('../../../../../components/report/report-style')
const css = style.getCliente()



export function start(detail) {

  const phpFile = 'server/php/sql/report.php'
  detail.inf = { entity: 'clientActivity', report: 'clientActivity-provider-report' }

  reportDB.select(detail, phpFile, (data) => {

    const body = generate(data)
    showReport(body);
  })

}/**/

function showReport(body) {
  let iframe = document.getElementById("reportIframe");
  iframe.src = 'about:blank';

  const doc = iframe.contentWindow.document;

  doc.open();
  doc.write(
    "<!DOCTYPE html><html><head></head><body>" + body + "</body></html>"
  );
  doc.close();
  iframe.contentWindow.print();
  iframe.onload = null;

}



function generate(data) {

  var body = ''
  // body += generateHeader()
  body += generateTop(data)
  body += generateTable(data)
  body += `</div> <!-- dataCont -->`
  body += `<div class="report-page">`

  return body
}

function generateTop(data) {

  let company_name = "";
  let current_dateTime = "";

  if (data.length > 0) {
    company_name = data[0].company_name;
    current_dateTime = data[0].current_dateTime;
  } else {
    let config = settings.getData();
    company_name = config.company;
    current_dateTime = timeDate.getdateshort() + ' ' + timeTime.formatAMPM();
  }

  return `
    <div ${css.title}>${company_name}</div>
    <div ${css.subtitle}>Receivable All Report As Of ${current_dateTime}</div>
  `;
}


function generateTable(data) {

  var totals = {
    current_due: 0,
    due_30_days: 0,
    due_31_to_60_days: 0,
    due_61_to_90_days: 0,
    due_over_90_days: 0,
    total_due: 0
  };

  var table = `
    <div ${css.paragraph}>
      This report consolidates the outstanding amounts owed to you by our company.
      Use it to track payments you are due from us.
    </div>

    <table ${css.table} class="dt-alterColor">
      <tr>
        <th ${css.th}>Code</th>
        <th ${css.th}>Current</th>
        <th ${css.th}>Due ≤ 30 days</th>
        <th ${css.th}>Due 31 to 60 days</th>
        <th ${css.th}>Due 61 to 90 days</th>
        <th ${css.th}>Due Over 90 days</th>
        <th ${css.th}>Total Due</th>
      </tr>
  `;

  if (data.length === 0) {
    table += `
      <tr>
        <td ${css.td} colspan="7" ${css.center}>No pending payments found.</td>
      </tr>
    </table>`;
    return table;
  }

  for (let i = 0; i < data.length; i++) {
    let row = data[i];

    let current_due = parseFloat(row.current_due.replace(/[$,]/g, '')) || 0;
    let due_30_days = parseFloat(row.due_30_days.replace(/[$,]/g, '')) || 0;
    let due_31_to_60_days = parseFloat(row.due_31_to_60_days.replace(/[$,]/g, '')) || 0;
    let due_61_to_90_days = parseFloat(row.due_61_to_90_days.replace(/[$,]/g, '')) || 0;
    let due_over_90_days = parseFloat(row.due_over_90_days.replace(/[$,]/g, '')) || 0;
    let total_due = parseFloat(row.total_due.replace(/[$,]/g, '')) || 0;

    totals.current_due += current_due;
    totals.due_30_days += due_30_days;
    totals.due_31_to_60_days += due_31_to_60_days;
    totals.due_61_to_90_days += due_61_to_90_days;
    totals.due_over_90_days += due_over_90_days;
    totals.total_due += total_due;

    table += `
      <tr ${rowStyle(i)}>
        <td ${css.td}>${row.code}</td>
        <td ${css.td}>${cashVal(current_due)}</td>
        <td ${css.td}>${cashVal(due_30_days)}</td>
        <td ${css.td}>${cashVal(due_31_to_60_days)}</td>
        <td ${css.td}>${cashVal(due_61_to_90_days)}</td>
        <td ${css.td}>${cashVal(due_over_90_days)}</td>
        <td ${css.totalCell}>${cashVal(total_due)}</td>
      </tr>
    `;
  }

  table += `
    <tr>
      <td ${css.totalLabel}>Total</td>
      <td ${css.totalCell}>${cashVal(totals.current_due)}</td>
      <td ${css.totalCell}>${cashVal(totals.due_30_days)}</td>
      <td ${css.totalCell}>${cashVal(totals.due_31_to_60_days)}</td>
      <td ${css.totalCell}>${cashVal(totals.due_61_to_90_days)}</td>
      <td ${css.totalCell}>${cashVal(totals.due_over_90_days)}</td>
      <td ${css.totalCell}>${cashVal(totals.total_due)}</td>
    </tr>
  </table>
  `;

  return table;
}


function cashVal(value) {
  return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
}

function rowStyle(i) {

  if (i % 2 === 0) { return '' }
  return css.trGray

}